import { confirm } from '@tribeplatform/react-ui-kit/Dialog';
export const confirmActionOnLockedPost = (intl) => async (post) => {
    if (post === null || post === void 0 ? void 0 : post.locked) {
        const confirmed = await confirm({
            title: intl.$t({
                id: 'Post.Utils.PostIsLockedConfirmationTitle',
                defaultMessage: 'This post is locked',
            }),
            description: intl.$t({
                id: 'Post.Utils.PostIsLockedConfirmationDescription',
                defaultMessage: 'As a community staff, you can perform actions on this post although it’s locked. Are you sure you want to continue?',
            }),
            proceedLabel: intl.$t({
                id: 'Generics.Continue',
                defaultMessage: 'Continue',
            }),
        });
        return confirmed;
    }
    return true;
};
//# sourceMappingURL=utils.js.map